export const getFrontendOrigin = window.location.origin